import type { CandidatePathParams } from './types';

export const candidateBriefQueryKeys = {
  all: ['candidate-brief'] as const,
  brief: ({ jobId, candidateId }: CandidatePathParams) =>
    [...candidateBriefQueryKeys.all, jobId, candidateId] as const,
  experience: ({ jobId, candidateId }: CandidatePathParams) =>
    [
      ...candidateBriefQueryKeys.brief({ jobId, candidateId }),
      'experience',
    ] as const,
  touchpoints: ({ jobId, candidateId }: CandidatePathParams) =>
    [
      ...candidateBriefQueryKeys.brief({ jobId, candidateId }),
      'touchpoints',
    ] as const,
};
